import { RecoveryRequest } from "@/features/recovery/recovery-request";

export default function RecoveryRequestPage() {
  return <RecoveryRequest />;
}
